module.exports = __webpack_public_path__ + "static/media/nus_logo_blue.9c41209e.svg";